module.exports = __webpack_public_path__ + "static/media/church.4f381c32.svg";